import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { SessionContext } from '../../../Context/SessionContext';
import Button from '../../../Button';
import s from './EmptyWatchedGroups.scss';
var EmptyWatchedGroups = function (props) {
    var t = useTranslation().t;
    var isLoggedIn = useContext(SessionContext).isLoggedIn;
    return (React.createElement("div", { className: s['groups-empty'] },
        React.createElement("div", { className: s['watch-groups'] }, isLoggedIn
            ? t('networkBar.groups.empty.header')
            : t('networkBar.groups.empty.anon.header')),
        React.createElement("div", { className: s['but-why'] }, isLoggedIn
            ? t('networkBar.groups.empty.text')
            : t('networkBar.groups.empty.anon.text')),
        !isLoggedIn && (React.createElement(Button, { view: "b1-1", height: "medium", className: s['signup'] }, t('networkBar.groups.empty.anon.join')))));
};
EmptyWatchedGroups.displayName = 'EmptyWatchedGroups';
export default EmptyWatchedGroups;
//# sourceMappingURL=EmptyWatchedGroups.js.map